<svg style="background:var(--anatomy-gray-100); padding: calc((152px - 17px) / 2) 10px" height="17" viewBox="0 0 135 17">
  <text id="Link" transform="translate(0 14)" fill="var(--anatomy-gray-700)" font-size="14" font-family="var(--anatomy-font)"><tspan x="0" y="0">Image Coming Soon</tspan></text>
</svg>
